export default __webpack_public_path__ + "static/media/arrow-right.831bf255.svg";